

import { apiClient } from '../../client'

export interface TopBrandHeroData {
  brand_name: string
  share_curr: number
  mom_pts: number
}

export interface Top10BrandsSosFacingData {
  top10_share_curr: number
}

export interface MarketMovementsData {
  market_movement_pts: number
}

export interface StrongStoresCoverageData {
  strong_store_coverage_pct: number
  total_stores: number
  stores_won: number
}

export interface BrandBySOSData {
  brand_name: string
  current_share: number
  previous_share: number
  variance_pts: number
}

export interface StoreCoverageData {
  city_name: string
  store_name: string
  current_share: number
  previous_share: number
  variance_pts: number
}

export interface SosFinalRowTreeMapData {
  category_name: string
  brand_name: string
  current_share: number
  previous_share: number
  variance_pts: number
}

export interface SosHeroKpisResponse {
  topBrandHero: TopBrandHeroData
  top10Brands: Top10BrandsSosFacingData
  marketMovement: MarketMovementsData
  strongStoreCoverage: StrongStoresCoverageData
}

function appendFilterParams(params: URLSearchParams, filters: any): void {
  if (!filters) return;

  const append = (key: string, value: any) => {
    if (Array.isArray(value) && value.length) {
      params.append(key, value.join(','));
    } else if (typeof value === 'string' && value.length) {
      params.append(key, value);
    } else if (value != null) {
      params.append(key, value.toString());
    }
  };

  append('client_ids', filters.client_ids);
  append('client_id', filters.client_id);

  append('category_ids', filters.category_ids);
  append('category_id', filters.category_id);

  append('subcategory_ids', filters.subcategory_ids);
  append('subcategory_id', filters.subcategory_id);

  append('brand_ids', filters.brand_ids);
  append('brand_id', filters.brand_id);

  append('start_date', filters.start_date);
  append('end_date', filters.end_date);
}

class SosBusinessKpiRepository {

  async getHeroKpis(filters?: any): Promise<SosHeroKpisResponse> {
    const params = new URLSearchParams()
    appendFilterParams(params, filters)

    const queryString = params.toString()
    const url = `/business-kpi-dashboards/sos/hero-kpis${queryString ? '?' + queryString : ''}`
    return apiClient.get(url)
  }

  async getBrandBySOS(filters?: any): Promise<BrandBySOSData[]> {
    const params = new URLSearchParams();
    appendFilterParams(params, filters);

    const queryString = params.toString();
    const url = `/business-kpi-dashboards/sos/brand-by-sos${queryString ? '?' + queryString : ''}`;
    return apiClient.get(url)
  }

  async getStoreCoverage(filters?: any): Promise<StoreCoverageData[]> {
    const params = new URLSearchParams();
    appendFilterParams(params, filters);

    const queryString = params.toString();
    const url = `/business-kpi-dashboards/sos/store-coverage${queryString ? '?' + queryString : ''}`;
    return apiClient.get(url)
  }

  async getSosFinalRowTreeMap(filters?: any): Promise<SosFinalRowTreeMapData[]> {
    const params = new URLSearchParams();
    appendFilterParams(params, filters);

    const queryString = params.toString();
    const url = `/business-kpi-dashboards/sos/final-row-tree-map${queryString ? '?' + queryString : ''}`;
    return apiClient.get(url)
  }
}

export const sosBusinessKpiRepository = new SosBusinessKpiRepository()

